(function ($) {
  $(function () {
    function findExactWord(str, word) {
      const regex = new RegExp(`\\b${word}\\b`);
      return regex.test(str);
    }
    function findLocation(location) {
      var locationsObj = [
        {
          location: "Eugene",
        },
        {
          location: "Portland",
        },
        {
          location: "Boise",
        },
        {
          location: "Salt Lake City",
        },
        {
          location: "Raleigh",
        },
        {
          location: "Reno",
        },
        {
          location: "Sacramento",
        },
        {
          location: "Fresno",
        },
        {
          location: "San Luis Obispo",
        },
        {
          location: "San Diego",
        },
        {
          location: "Las Vegas",
        },
        {
          location: "Phoenix",
        },
        {
          location: "Houston",
        },
      ];
      let locationName = '';
      locationsObj.some((item) => {
        let locFinder = findExactWord(location, item.location);
        if (locFinder) {
          locationName = item.location;
          return true;
        }
        return false;
      });

      return locationName;
    }
    function findEventId(location) {
      var eventIds = [
        {
          location: "Eugene",
          eventid: 'nu22121829',
        },
        {
          location: "Portland",
          eventid: 'Dk22121855',
        },
        {
          location: "Boise",
          eventid: 'gy22121868',
        },
        {
          location: "Salt Lake City",
          eventid: 'WI22121878',
        },
        {
          location: "Raleigh",
          eventid: 'gn22121884',
        },
        {
          location: "Reno",
          eventid: 'DI22121894',
        },
        {
          location: "Sacramento",
          eventid: 'Tz22121906',
        },
        {
          location: "Fresno",
          eventid: 'cE22121921',
        },
        {
          location: "San Luis Obispo",
          eventid: 'Me22121930',
        },
        {
          location: "San Diego",
          eventid: 'jC22121938',
        },
        {
          location: "Las Vegas",
          eventid: 'tu22121944',
        },
        {
          location: "Phoenix",
          eventid: 'og22121952',
        },
        {
          location: "Houston",
          eventid: 'eg22121959',
        },
      ];

      let eventId = 0;
      eventIds.some((item) => {
        let evendFinder = findExactWord(location, item.location);
        if (evendFinder) {
          eventId = item.eventid;
          return true;
        }
        return false;
      });

      return eventId;
    }
    function findCampaignID(location) {
      var campaignIds = [
        {
          location: "Eugene",
          campaignid: 232,
        },
        {
          location: "Boise",
          campaignid: 234,
        },
        {
          location: "Fresno",
          campaignid: 239,
        },
        {
          location: "Houston",
          campaignid: 244,
        },
        {
          location: "Las Vegas",
          campaignid: 242,
        },
        {
          location: "Portland",
          campaignid: 233,
        },
        {
          location: "Phoenix",
          campaignid: 243,
        },
        {
          location: "Raleigh",
          campaignid: 236,
        },
        {
          location: "Reno",
          campaignid: 237,
        },
        {
          location: "Sacramento",
          campaignid: 238,
        },
        {
          location: "Salt Lake City",
          campaignid: 235,
        },
        {
          location: "San Diego",
          campaignid: 241,
        },
        {
          location: "San Luis Obispo",
          campaignid: 240,
        },
      ];
      let capaignId = 0;
      campaignIds.some((item) => {
        let evendFinder = findExactWord(location, item.location);
        if (evendFinder) {
          capaignId = item.campaignid;
          return true;
        }
        return false;
      });

      return capaignId;
    }
    let bbqForm = $("#wpcf7-f803-o1");
    if (bbqForm && bbqForm.length) {
      $(document).on("change", "#bbq_locations", function () {
        let locationVal = $(this).val();
        let location = findLocation(locationVal);
        let eventId = findEventId(location);
        let campaignId = findCampaignID(location);
        $('.cad-form .hide-me input[name="location"]').val(location);
        $('.cad-form .hide-me input[name="eventid"]').val(eventId);
        $('.cad-form .hide-me input[name="campaignId"]').val(campaignId);
      });
    }

  });
})(jQuery);
